
import { CustomerService } from "@/services";
import Vue from "vue";
import { ConfirmResult } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			downloadingTxt: false
		};
	},
	props: {
		onReady: {
			type: Function,
			required: true
		}
	},
	methods: {
		cancelClicked(){
			this.onReady(ConfirmResult.CANCEL);
		},
		noClicked(){
			this.onReady(ConfirmResult.NO);
		},
		yesClicked(){
			this.onReady(ConfirmResult.YES);
		},
		async downloadTxt(){
			if (this.downloadingTxt) return;
			this.downloadingTxt = true;
			try{
				await CustomerService.getWithAmbigousVatTxt();
			}catch(err){

			}
			this.downloadingTxt = false;
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
